import axios from "axios";

const API_KEY = "AIzaSyB9HB_gIk4w-mXHik77xcR6xrS1uBk2Zz0";

export default axios.create({
  baseURL: "https://www.googleapis.com/youtube/v3",
  params: {
    part: "snippet",
    maxResults: 5,
    key: API_KEY,
    type: "video"
  }
});
